import { CSSProperties, memo } from 'react';
import { UserLocation } from '../../redux/user/userSlice';
import { LocationSelectorProvider } from './LocationSelectorContext';
import LocationSelectorModals from './LocationSelectorModals';
import OpenLocationSelectionButton from './OpenLocationSelectionButton';

interface UserLocationSelectorProviderProps {
  onLocationSelect: (location: UserLocation) => void;
  selectedLocation?: UserLocation;
  showError?: boolean;
  buttonStyles?: CSSProperties;
}

const UserLocationSelector = memo(
  ({
    onLocationSelect,
    selectedLocation,
    showError,
    buttonStyles,
  }: UserLocationSelectorProviderProps) => {
    return (
      <LocationSelectorProvider
        onLocationSelect={onLocationSelect}
        selectedLocation={selectedLocation}
        showError={showError}
      >
        <OpenLocationSelectionButton buttonStyles={buttonStyles} />
        <LocationSelectorModals />
      </LocationSelectorProvider>
    );
  },
);

export default UserLocationSelector;
